// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TableHeader.module.css */

.adminPortal_tableCell__u0Zxb {
  height: 80px !important;
  background-color: #ffff !important;
  font-weight: 600 !important;
  position: relative !important;
  white-space: nowrap !important; /* Corrected syntax */
  /* box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1) !important; */
}

.adminPortal_tableHead__TIZhB {
  box-shadow: 0px -4px 6px rgba(0, 0, 0, 0.1) !important; /* Top shadow */
  position: sticky !important;
  top: 0 !important; /* Ensures it stays at the top */
  z-index: 10 !important; /* Keeps it above other content */
  background-color: black !important; /* Avoids transparency issues */
  /* border: 1px solid #9b9999 !important; */
}

.adminPortal_topBorderDiv__toWai {
  background-color: #eaebed !important;
  width: 100% !important;
  height: 55% !important;
  padding: 4px 15px !important; /* px-10 py-1 equivalent */
  position: absolute !important;
  top: 35px !important;
  left: 0 !important;
  border-top: 2px solid #e5e7eb !important; /* border-gray-200 */
}

.adminPortal_tableCell__u0Zxb:not(:last-child) {
  /* border-right: 1px solid #ccc !important; */
}
.adminPortal_headCellHeading__VqVDD {
  position: absolute;
  top: 4px;
}

.adminPortal_searchInput__XHCno {
  width: 80% !important; /* Keep it responsive */
  font-size: 12px !important;
  color: #1f2937 !important; /* text-gray-900 */
  background-color: transparent !important;

  font-weight: 400 !important;
  outline: none !important;
  border: none !important; /* Remove other borders */
  border-bottom: 1px solid #57595b !important; /* Add bottom border */
  padding: 5px 0px 0px 0px !important; /* Improve padding */
}

.adminPortal_searchDropdownList__fGoW0 {
  width: 90% !important; /* Keep it responsive */
  font-size: 12px !important;
  color: #1f2937 !important; /* text-gray-900 */
  background-color: transparent !important;
  height: -webkit-fill-available;
  font-weight: 400 !important;
  outline: none !important;
  border: none !important; /* Remove other borders */
  border-bottom: 1px solid #57595b !important; /* Add bottom border */
  padding: 5px 0px 5px 0px !important; /* Improve padding */
}
/* TableContainer.module.css */

.adminPortal_tableGround__BbqSk {
  background-color: white;
  height: 100%;
}

.adminPortal_tableContainer__QjV9C {
  height: calc(95vh - 150px) !important;
  max-height: calc(95vh - 150px) !important;
  overflow-y: auto !important; /* Adds scroll when content exceeds height */
  margin-top: 8px !important; /* mt-2 in Tailwind (8px) */
  border-radius: 8px !important; /* rounded-lg */
}

.adminPortal_tableGap__-DpUS {
  padding: 0 20px;
}

.adminPortal_tableRowHead__I2fSK {
  height: 50px;
  cursor: pointer;
}

.adminPortal_tableRow__PCVzk {
  font-size: 13px !important; /* Ensures MUI does not override */
  padding: 0px 4px !important;
  /* border-left: 1px solid #efecec !important;
  border-right: 1px solid #efecec !important; */
  color: #6b7280 !important;
  max-width: 50%;
}

.adminPortal_tableRow__PCVzk span {
  margin: 0 0.6rem;
}

.adminPortal_tableLoading__9fdVI {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90vh;
}

.adminPortal_active__HkFjk {
  background-color: #d0f4ff !important;
  color: #093ebc !important;
}

.adminPortal_inactive__ii-H5 {
  background-color: #fbf5c4 !important;
  color: #885401 !important;
}

.adminPortal_blacklisted__pqf25 {
  background-color: #ffdfdf !important;
  color: #8c0909 !important;
}

/* Audit status Chip Colors */

.adminPortal_chip__IuwNH {
  background-color: var(--default-bg) !important;
  color: var(--default-text) !important;
}

.adminPortal_machineChip__lecST {
  background-color: var(--machineChip-color) !important;
  color: var(--machineChip-text-color) !important;
}
.adminPortal_fabricationChip__PtLhV {
  background-color: var(--fabricationChip-color) !important;
  color: var(--fabricationChip-text-color) !important;
}

.adminPortal_verified__Jbt8w {
  background-color: #ddffd3 !important;
  color: #358c09 !important;
}

.adminPortal_unverified__AsJ9r {
  background-color: #ffd98e !important;
  color: #c77903 !important;
}

.adminPortal_platinum__T1Zod {
  background-color: #d3cece !important;
  color: #ffffff !important;
}

.adminPortal_gold__9RUDz {
  background-color: #ffd98e !important;
  color: #c77903 !important;
}

.adminPortal_silver__\\+Pi3w {
  background-color: #c7d4c8 !important;
  color: #575655 !important;
}

/* Global Custom Select Styles */
.adminPortal_custom-select-container__eCAGH {
  position: relative;
  width: 100%;
}

.adminPortal_custom-select__maC2v {
  appearance: none;
  border: 1px solid #d1d5db; /* gray-300 */
  font-size: 0.875rem; /* text-sm */
  border-radius: 0.5rem; /* rounded-lg */
  padding: 0.625rem 2.5rem 0.625rem 0.75rem; /* p-2.5 pr-10 */
  width: 100%;
  background-color: white;
  outline: none;
  transition: border-color 0.3s ease;
}

.adminPortal_custom-select__maC2v:focus {
  border-color: #3b82f6; /* blue-500 */
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.5);
}

.adminPortal_custom-select__maC2v.adminPortal_dark__YYvjW {
  border-color: #4b5563; /* gray-600 */
}

.adminPortal_custom-select__maC2v:focus.adminPortal_dark__YYvjW {
  border-color: #3b82f6;
}

.adminPortal_dropdown-icon__T-qjA {
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #6b7280; /* gray-500 */
}

.adminPortal_truncateText__kx8Or {
  display: block;
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
`, "",{"version":3,"sources":["webpack://./src/styles/adminPortal.module.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAE3B;EACE,uBAAuB;EACvB,kCAAkC;EAClC,2BAA2B;EAC3B,6BAA6B;EAC7B,8BAA8B,EAAE,qBAAqB;EACrD,2DAA2D;AAC7D;;AAEA;EACE,sDAAsD,EAAE,eAAe;EACvE,2BAA2B;EAC3B,iBAAiB,EAAE,gCAAgC;EACnD,sBAAsB,EAAE,iCAAiC;EACzD,kCAAkC,EAAE,+BAA+B;EACnE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;EACtB,sBAAsB;EACtB,4BAA4B,EAAE,0BAA0B;EACxD,6BAA6B;EAC7B,oBAAoB;EACpB,kBAAkB;EAClB,wCAAwC,EAAE,oBAAoB;AAChE;;AAEA;EACE,6CAA6C;AAC/C;AACA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,qBAAqB,EAAE,uBAAuB;EAC9C,0BAA0B;EAC1B,yBAAyB,EAAE,kBAAkB;EAC7C,wCAAwC;;EAExC,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB,EAAE,yBAAyB;EAClD,2CAA2C,EAAE,sBAAsB;EACnE,mCAAmC,EAAE,oBAAoB;AAC3D;;AAEA;EACE,qBAAqB,EAAE,uBAAuB;EAC9C,0BAA0B;EAC1B,yBAAyB,EAAE,kBAAkB;EAC7C,wCAAwC;EACxC,8BAA8B;EAC9B,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB,EAAE,yBAAyB;EAClD,2CAA2C,EAAE,sBAAsB;EACnE,mCAAmC,EAAE,oBAAoB;AAC3D;AACA,8BAA8B;;AAE9B;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;EACzC,2BAA2B,EAAE,4CAA4C;EACzE,0BAA0B,EAAE,2BAA2B;EACvD,6BAA6B,EAAE,eAAe;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,0BAA0B,EAAE,kCAAkC;EAC9D,2BAA2B;EAC3B;+CAC6C;EAC7C,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,6BAA6B;;AAE7B;EACE,8CAA8C;EAC9C,qCAAqC;AACvC;;AAEA;EACE,qDAAqD;EACrD,+CAA+C;AACjD;AACA;EACE,yDAAyD;EACzD,mDAAmD;AACrD;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,yBAAyB,EAAE,aAAa;EACxC,mBAAmB,EAAE,YAAY;EACjC,qBAAqB,EAAE,eAAe;EACtC,yCAAyC,EAAE,gBAAgB;EAC3D,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,qBAAqB,EAAE,aAAa;EACpC,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB,EAAE,aAAa;AACtC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,cAAc,EAAE,aAAa;AAC/B;;AAEA;EACE,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB","sourcesContent":["/* TableHeader.module.css */\n\n.tableCell {\n  height: 80px !important;\n  background-color: #ffff !important;\n  font-weight: 600 !important;\n  position: relative !important;\n  white-space: nowrap !important; /* Corrected syntax */\n  /* box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.1) !important; */\n}\n\n.tableHead {\n  box-shadow: 0px -4px 6px rgba(0, 0, 0, 0.1) !important; /* Top shadow */\n  position: sticky !important;\n  top: 0 !important; /* Ensures it stays at the top */\n  z-index: 10 !important; /* Keeps it above other content */\n  background-color: black !important; /* Avoids transparency issues */\n  /* border: 1px solid #9b9999 !important; */\n}\n\n.topBorderDiv {\n  background-color: #eaebed !important;\n  width: 100% !important;\n  height: 55% !important;\n  padding: 4px 15px !important; /* px-10 py-1 equivalent */\n  position: absolute !important;\n  top: 35px !important;\n  left: 0 !important;\n  border-top: 2px solid #e5e7eb !important; /* border-gray-200 */\n}\n\n.tableCell:not(:last-child) {\n  /* border-right: 1px solid #ccc !important; */\n}\n.headCellHeading {\n  position: absolute;\n  top: 4px;\n}\n\n.searchInput {\n  width: 80% !important; /* Keep it responsive */\n  font-size: 12px !important;\n  color: #1f2937 !important; /* text-gray-900 */\n  background-color: transparent !important;\n\n  font-weight: 400 !important;\n  outline: none !important;\n  border: none !important; /* Remove other borders */\n  border-bottom: 1px solid #57595b !important; /* Add bottom border */\n  padding: 5px 0px 0px 0px !important; /* Improve padding */\n}\n\n.searchDropdownList {\n  width: 90% !important; /* Keep it responsive */\n  font-size: 12px !important;\n  color: #1f2937 !important; /* text-gray-900 */\n  background-color: transparent !important;\n  height: -webkit-fill-available;\n  font-weight: 400 !important;\n  outline: none !important;\n  border: none !important; /* Remove other borders */\n  border-bottom: 1px solid #57595b !important; /* Add bottom border */\n  padding: 5px 0px 5px 0px !important; /* Improve padding */\n}\n/* TableContainer.module.css */\n\n.tableGround {\n  background-color: white;\n  height: 100%;\n}\n\n.tableContainer {\n  height: calc(95vh - 150px) !important;\n  max-height: calc(95vh - 150px) !important;\n  overflow-y: auto !important; /* Adds scroll when content exceeds height */\n  margin-top: 8px !important; /* mt-2 in Tailwind (8px) */\n  border-radius: 8px !important; /* rounded-lg */\n}\n\n.tableGap {\n  padding: 0 20px;\n}\n\n.tableRowHead {\n  height: 50px;\n  cursor: pointer;\n}\n\n.tableRow {\n  font-size: 13px !important; /* Ensures MUI does not override */\n  padding: 0px 4px !important;\n  /* border-left: 1px solid #efecec !important;\n  border-right: 1px solid #efecec !important; */\n  color: #6b7280 !important;\n  max-width: 50%;\n}\n\n.tableRow span {\n  margin: 0 0.6rem;\n}\n\n.tableLoading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 90vh;\n}\n\n.active {\n  background-color: #d0f4ff !important;\n  color: #093ebc !important;\n}\n\n.inactive {\n  background-color: #fbf5c4 !important;\n  color: #885401 !important;\n}\n\n.blacklisted {\n  background-color: #ffdfdf !important;\n  color: #8c0909 !important;\n}\n\n/* Audit status Chip Colors */\n\n.chip {\n  background-color: var(--default-bg) !important;\n  color: var(--default-text) !important;\n}\n\n.machineChip {\n  background-color: var(--machineChip-color) !important;\n  color: var(--machineChip-text-color) !important;\n}\n.fabricationChip {\n  background-color: var(--fabricationChip-color) !important;\n  color: var(--fabricationChip-text-color) !important;\n}\n\n.verified {\n  background-color: #ddffd3 !important;\n  color: #358c09 !important;\n}\n\n.unverified {\n  background-color: #ffd98e !important;\n  color: #c77903 !important;\n}\n\n.platinum {\n  background-color: #d3cece !important;\n  color: #ffffff !important;\n}\n\n.gold {\n  background-color: #ffd98e !important;\n  color: #c77903 !important;\n}\n\n.silver {\n  background-color: #c7d4c8 !important;\n  color: #575655 !important;\n}\n\n/* Global Custom Select Styles */\n.custom-select-container {\n  position: relative;\n  width: 100%;\n}\n\n.custom-select {\n  appearance: none;\n  border: 1px solid #d1d5db; /* gray-300 */\n  font-size: 0.875rem; /* text-sm */\n  border-radius: 0.5rem; /* rounded-lg */\n  padding: 0.625rem 2.5rem 0.625rem 0.75rem; /* p-2.5 pr-10 */\n  width: 100%;\n  background-color: white;\n  outline: none;\n  transition: border-color 0.3s ease;\n}\n\n.custom-select:focus {\n  border-color: #3b82f6; /* blue-500 */\n  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.5);\n}\n\n.custom-select.dark {\n  border-color: #4b5563; /* gray-600 */\n}\n\n.custom-select:focus.dark {\n  border-color: #3b82f6;\n}\n\n.dropdown-icon {\n  position: absolute;\n  right: 0.5rem;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  color: #6b7280; /* gray-500 */\n}\n\n.truncateText {\n  display: block;\n  width: 90%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableCell": `adminPortal_tableCell__u0Zxb`,
	"tableHead": `adminPortal_tableHead__TIZhB`,
	"topBorderDiv": `adminPortal_topBorderDiv__toWai`,
	"headCellHeading": `adminPortal_headCellHeading__VqVDD`,
	"searchInput": `adminPortal_searchInput__XHCno`,
	"searchDropdownList": `adminPortal_searchDropdownList__fGoW0`,
	"tableGround": `adminPortal_tableGround__BbqSk`,
	"tableContainer": `adminPortal_tableContainer__QjV9C`,
	"tableGap": `adminPortal_tableGap__-DpUS`,
	"tableRowHead": `adminPortal_tableRowHead__I2fSK`,
	"tableRow": `adminPortal_tableRow__PCVzk`,
	"tableLoading": `adminPortal_tableLoading__9fdVI`,
	"active": `adminPortal_active__HkFjk`,
	"inactive": `adminPortal_inactive__ii-H5`,
	"blacklisted": `adminPortal_blacklisted__pqf25`,
	"chip": `adminPortal_chip__IuwNH`,
	"machineChip": `adminPortal_machineChip__lecST`,
	"fabricationChip": `adminPortal_fabricationChip__PtLhV`,
	"verified": `adminPortal_verified__Jbt8w`,
	"unverified": `adminPortal_unverified__AsJ9r`,
	"platinum": `adminPortal_platinum__T1Zod`,
	"gold": `adminPortal_gold__9RUDz`,
	"silver": `adminPortal_silver__+Pi3w`,
	"custom-select-container": `adminPortal_custom-select-container__eCAGH`,
	"custom-select": `adminPortal_custom-select__maC2v`,
	"dark": `adminPortal_dark__YYvjW`,
	"dropdown-icon": `adminPortal_dropdown-icon__T-qjA`,
	"truncateText": `adminPortal_truncateText__kx8Or`
};
export default ___CSS_LOADER_EXPORT___;
